const CELL_DEFAULT_VALUE = ''
const COLUMN_NAME_PATTERN = /^[$A-Z_][0-9A-Z_$]*$/i
const RESERVED_KEYWORDS = ['break', 'do', 'instanceof', 'typeof', 'case', 'else', 'new', 'var', 'catch', 'finally', 'return', 'void', 'continue', 'for', 'switch', 'while', 'debugger', 'function', 'this', 'with', 'default', 'if', 'throw', 'delete', 'in', 'try', 'class', 'enum', 'extends', 'super', 'const', 'export', 'import', 'implements', 'let', 'private', 'public', 'yield', 'interface', 'package', 'protected', 'static', 'null', 'true', 'false']

function newRowWithColumns (columns) {
  const row = {}

  columns.forEach(columnName => {
    row[columnName] = CELL_DEFAULT_VALUE
  })

  return row
}

exports.datasource = {
  addColumn: function (rows, name) {
    if (rows.length) {
      return rows.map(row => {
        row[name] = ''
        return row
      })
    }

    return [{ [name]: '' }]
  },
  changeColumnName: function (rows, oldColumnName, newColumnName) {
    const columns = Object.keys(rows[0])

    return rows.map(oldRow => {
      const row = {}
      for (const name of columns) { // eslint-disable-line no-unused-vars
        if (name === oldColumnName) {
          row[newColumnName] = oldRow[name]
        } else {
          row[name] = oldRow[name]
        }
      }

      return row
    })
  },
  addRow: function (rows) {
    const columns = Object.keys(rows[0])

    return [...rows, newRowWithColumns(columns)]
  },
  deleteSelectedRows: function (rows) {
    return rows.filter(row => !row._checked)
  },
  deleteColumn: function (rows, columns, columnName) {
    if (columns.length === 1) return []

    return rows.map(row => {
      delete row[columnName]
      return row
    })
  },
  rowsForAPI: function (rows) {
    return rows.map(row => {
      const newRow = { ...row }

      delete newRow._index
      delete newRow._checked
      return newRow
    })
      .filter(row => {
        for (const key in row) { // eslint-disable-line no-unused-vars
          if (row[key]) {
            return true
          }
        }
        return false
      })
  },
  editCell: function (rows, rowId, column, value) {
    const index = Number(rowId)

    return rows.map(row => {
      if (row._index === index) {
        row[column] = value
      }

      return row
    })
  },
  rowsForSpreadsheet: function (rows) {
    return rows.map((row, index) => {
      row._index = index
      row._checked = !!row._checked
      
      return row
    })
  },
  columnNameIsValid (name) {
    return COLUMN_NAME_PATTERN.test(name) && !RESERVED_KEYWORDS.includes(name)
  }
}



// WEBPACK FOOTER //
// /app/js/components/lib/datasource.js